/* eslint-disable */
import { CONFIG } from "~/config";
import HistorySuggestItem from "~/es6/history.suggest.item";
import Scene from "~/scene";
import { store } from "~/state/store";
//import { search } from "~/util/providers/search";
import { getPOI } from "~/route/utils";
import { isLocationUsable } from "~/util/validation";
import { addListener, makeEvent, removeListener } from "~/lib/signals";
import { isPoiSourceSafe } from "~/util/wasm";

const TIMEOUT = 300;

export interface ISuggestPOI {
	source: string;
	id: number | string;
	mark: {
		lon: number;
		lat: number;
	};
	title: string;
}

interface IInputSuggestMapClickProps {
	input: HTMLInputElement;
	onSelect?: (poi: ISuggestPOI) => void;
	onFocus?: (event: FocusEvent) => void;
	onBlur?: () => void;
	onLoadingStart?: () => void;
	onLoadingEnd?: () => void;
}

export class InputSuggestMapClick {
	#props: IInputSuggestMapClickProps;

	#cursor: any;

	#suggestedItems: Array<any>;

	#prehistorikRemove: boolean;

	#isEnterReq: boolean;

	#suggest: any;

	#toID: number;

	#clickListener: string;

	constructor(props: IInputSuggestMapClickProps) {
		this.#props = props;
		this.#suggestedItems = [];
		this.#cursor = null;
		this.#prehistorikRemove = false;
		this.#toID = 0;
		this.#isEnterReq = false;

		// do inputu je navaseny klik do mapy
		this.#props.input.addEventListener("focus", (event: FocusEvent) => {
			this.#inputFocus(event);
			makeEvent("inputmapclick-focus", this);
			this.#clickListener = addListener({}, "inputmapclick-click", data => {
				this.wasmMapClick(data);
			});
		}, false);
		this.#props.input.addEventListener("blur", () => {
			this.#inputBlur();
			makeEvent("inputmapclick-blur", this);
			this.#clickListener && removeListener(this.#clickListener);
			this.#clickListener = null;
		}, false);
		this.#props.input.addEventListener("keydown", (event: KeyboardEvent) => {
			const value = this.#props.input.value.trim();

			switch (event.key) {
				/*case "Tab":
					if (value.length && !this.#suggestedItems.length) {
						search(value).promise.then(data => {
							if (data && data.result.length) {
								const firstResult = data.result[0];
								const suggestData = Object.assign(firstResult, {
									name: firstResult.title,
									longitude: firstResult.mark.lon,
									latitude: firstResult.mark.lat,
								});

								this._setSuggestData(suggestData);
							}
						}, () => {});
					}
					break;*/
				case "Escape":
					this.#suggest.close();
					this.#suggestedItems = [];
					break;

				default:
					//
			}
		});
		// naseptavac
		this.#suggest = new SMap.Suggest(this.#props.input, {
			factory: (data, pos) => {
				const item = new HistorySuggestItem(data, pos);

				item.historyDeleteCallback = () => {
					this.#prehistorikRemove = true;
				};

				return item;
			},
			provider: new SMap.SuggestProvider({
				url: `${CONFIG.requestUrl}/suggest/`,
				poiaggUrl: `${CONFIG.requestUrl}/poiagg`,
				limit: 8,
			}),
			abTest: CONFIG.abTest ? CONFIG.abTest.flags : "",
		});
		this.#suggest.addListener("suggest", suggestData => {
			this.#isEnterReq = false;
			this._clearTO();
			this._setSuggestData(suggestData.data);
		});
		this.#suggest.addListener("enter", () => {
			if (this.#props.input.value) {
				this.#suggest.send();
				this.#isEnterReq = true;
			}
		});
		this.#suggest.getProvider().updateParams(paramsObj => {
			const state = store.getState();
			const { user } = state.user;
			const { longitude, latitude, zoom } = state.map;

			paramsObj.lon = longitude;
			paramsObj.lat = latitude;
			paramsObj.zoom = zoom;
			paramsObj.lang = CONFIG.langPriority.join(",");
			paramsObj.personalize = user.state === "green" ? 1 : 0;
			paramsObj.pubtBoost = 0;
			paramsObj.count = 8;

			if (isLocationUsable(state.user.location)) {
				paramsObj.userLat = state.user.location.latitude;
				paramsObj.userLon = state.user.location.longitude;
				paramsObj.userAccuracy = state.user.location.accuracy;
			}
		});
		this.#suggest.addListener("request-items", responseData => {
			this.#suggestedItems = Array.isArray(responseData) ? responseData : [];

			if (this.#isEnterReq && this.#suggestedItems.length && !this.#prehistorikRemove) {
				this._setSuggestData(this.#suggestedItems[0]);
				this.#suggestedItems = [];
				this.#inputBlur();
			}

			this.#isEnterReq = false;
		});
	}

	destroy() {
		if (this.#cursor) {
			Mapy.Cursor.remove(this.#cursor);
			this.#cursor = null;
		}
		this.#suggest.destroy();
		this.#clickListener && removeListener(this.#clickListener);
		this.#clickListener = null;
	}

	setData(data) {
		let geometry = null;

		if (data.mark) {
			geometry = Scene.coordsToString([Scene.coordsFromWGS84(data.mark.lon, data.mark.lat)]);
		} else if (data.coords) {
			geometry = Scene.coordsToString([data.coords]);
		}

		const sendData = {
			id: data.id,
			source: data.source,
			geometry,
			title: data.title,
			desc: data.secondRow || data.multiTitle ? data.multiTitle.slice(1).join(", ") : data.title,
			typeId: data.poiTypeId || data.typeId || 0,
			from: "history",
		};

		// pokud nahodou prijde source a id a je typ point, sereme na ne
		if (data.dataType === "point") {
			const coor = Scene.stringToCoords(geometry)[0];

			sendData.source = "coor";
			sendData.id = coor.toWGS84().join(",");
			sendData.title = coor.toWGS84(2).join(",");
		}

		this._sendSignal(sendData);
	}

	async mapClick(signal, target) {
		this.#props.input.blur();

		if (target) { // pokud mame poiku
			let data = null;

			if (typeof target.getPOI === "function") {
				data = target.getPOI();
			} else {
				const coords = target.getCoords().toWGS84();

				data = {
					x: coords[0],
					y: coords[1],
					title: target.getCoords().toWGS84(0).join(","),
					id: target.getPlainId(),
					source: target.getSource(),
				};
			}

			// kotrolujeme, zda uz souradnice mame z descriptionu a pokud ne, vezmeme z lookupu
			const coor = data.x ? Scene.coordsFromWGS84(data.x, data.y) : Scene.coordsFromWGS84(data.mark.lon, data.mark.lat);
			const poi = {
				title: data.title,
				desc: data.address ? data.address.join(", ") : data.multiTitle && data.multiTitle[1] ? data.multiTitle[1] : "",
				geometry: Scene.coordsToString([coor]),
				id: data.id,
				source: data.source,
				typeId: data.typeId,
				from: "mapClick",
			};

			this._sendSignal(poi);
		} else {
			const coords = await Scene.coordsFromEventAsync(signal);

			getPOI(coords).then(poi => {
				poi.from = "mapClick";
				this._sendSignal(poi);
			}, () => {});
		}
	}

	wasmMapClick(data) {
		const coords = Scene.coordsFromWGS84(data.data.longitude, data.data.latitude);

		this.#props.input.blur();

		if (data.data.poi && isPoiSourceSafe(data.data.poi.source)) { // pokud mame poiku
			const poi = {
				title: data.data.poi.title,
				desc: "",
				geometry: Scene.coordsToString([Scene.coordsFromWGS84(data.data.poi.mark.lon, data.data.poi.mark.lat)]),
				id: data.data.poi.id,
				source: data.data.poi.source,
				typeId: data.data.poi.typeId,
				from: "mapClick",
			};

			this._sendSignal(poi);
		} else {
			getPOI(coords).then(poi => {
				poi.from = "mapClick";
				this._sendSignal(poi);
			}, () => {});
		}
	}

	/**
	 * Nastaveni dat suggest -> item.
	 * Bud pri blur/vyber z naseptavace.
	 *
	 * @param   {Object}  data
	 */
	_setSuggestData(data) {
		this.#suggestedItems = [];
		this._sendSignal({
			id: data.id,
			source: data.source,
			geometry: Scene.coordsToString([Scene.coordsFromWGS84(data.longitude, data.latitude)]),
			title: data.title,
			desc: data.secondRow,
			typeId: data.poiTypeId || 0,
			from: "suggest",
		});
	}

	#inputFocus(event: FocusEvent) {
		if (!CONFIG.wasmEnabled) {
			this.#cursor = Mapy.Cursor.add({
				cursor: "crosshair",
				callback: this,
			});
		}
		this.#props.onFocus && this.#props.onFocus(event);
	}

	#inputBlur() {
		this.#isEnterReq = false;
		if (this.#cursor) {
			Mapy.Cursor.remove(this.#cursor);
			this.#cursor = null;
		}

		this._clearTO();
		this.#toID = window.setTimeout(() => {
			const value = this.#props.input.value.trim();

			if (value.length && !this.#prehistorikRemove) {
				const firstItem = this.#suggestedItems.length ? this.#suggestedItems[0] : null;

				if (firstItem) {
					this._setSuggestData(firstItem);
				}
			}

			this.#suggestedItems = [];
			this.#suggest.clearItems();
			this.#prehistorikRemove = false;

			if (document.activeElement !== this.#props.input) {
				this.#props.onBlur && this.#props.onBlur();
			}
		}, TIMEOUT);

		this.#props.onBlur && this.#props.onBlur();
	}

	_sendSignal(data) {
		this.#props.onSelect && this.#props.onSelect(data);
	}

	_clearTO() {
		if (this.#toID) {
			clearTimeout(this.#toID);
			this.#toID = 0;
		}
	}
}
